var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcBlackTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8409 6.32686C16.7596 12.6825 12.879 17.0362 7.08586 17.3106C4.69711 17.425 2.96586 16.6169 1.45898 15.6137C3.22461 15.91 5.41523 15.17 6.58586 14.1206C4.85461 13.9444 3.82961 13.0219 3.35023 11.5369C3.85086 11.6262 4.37773 11.6037 4.85336 11.4975C3.29086 10.95 2.17586 9.93936 2.11773 7.82061C2.55586 8.02936 3.01336 8.22499 3.61961 8.26374C2.45023 7.56749 1.58648 5.02248 2.57648 3.33936C4.31086 5.32998 6.39711 6.95561 9.82399 7.17624C8.96398 3.32436 13.8371 1.23561 15.8765 3.82436C16.7384 3.64998 17.4402 3.30686 18.1159 2.93436C17.8371 3.82936 17.3021 4.45311 16.6502 4.95373C17.3659 4.85248 18.0009 4.66936 18.5415 4.38936C18.2065 5.11873 17.4715 5.77499 16.8402 6.32686H16.8409Z",
    fill: "#191919"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcBlackTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_black_twitter.835e745221c26d3a7bd2073a2669cd25.svg";